import { render, staticRenderFns } from "./LatestProject.vue?vue&type=template&id=540e0b9b&"
import script from "./LatestProject.vue?vue&type=script&lang=js&"
export * from "./LatestProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports